import * as React from "react";
const SvgFiRrAdmin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-admin_svg__a)">
      <path
        fill="#062147"
        d="M17 11c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5m-8 0c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3m9.937 11.648a1.001 1.001 0 0 1-1.874.703c-.753-2.004-2.788-3.352-5.063-3.352s-4.311 1.347-5.063 3.352a1 1 0 0 1-1.873-.704c1.045-2.78 3.832-4.648 6.937-4.648s5.892 1.868 6.937 4.648zm2.25-5.599a1 1 0 0 1-1.385.285l-1.27-.836a1.5 1.5 0 0 1-.465-2.005 7 7 0 0 0 .875-4.409c-.396-3.144-2.973-5.683-6.126-6.039-2.027-.226-3.973.388-5.479 1.733A7.01 7.01 0 0 0 5 10.999a7 7 0 0 0 .932 3.492 1.507 1.507 0 0 1-.463 2.007l-1.271.836a1 1 0 0 1-1.385-.285 1 1 0 0 1 .285-1.385l.88-.579A9 9 0 0 1 2.999 11c0-1.433.354-2.825.991-4.077l-.893-.588a.999.999 0 1 1 1.1-1.67l.892.587c.282-.34.581-.667.914-.965a9 9 0 0 1 4.996-2.224V.999a1 1 0 1 1 2 0v1.056q.02 0 .041.002c2.333.263 4.418 1.458 5.868 3.194l.892-.588a1 1 0 0 1 1.1 1.67l-.884.582c.463.899.779 1.882.91 2.917a9 9 0 0 1-.905 5.251l.88.58a1 1 0 0 1 .285 1.385z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-admin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAdmin;
